import { ViewStream } from "spyne";

export class PageDocsItemBlockExternalCodesandbox extends ViewStream {
  constructor(props = {}) {
    props.tagName = "iframe";
    props.style =
      "width:100%; height: 500px; border:0; border-radius: 4px; overflow:hidden;";
    props.allow =
      "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking";
    props.sandbox =
      "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts";

    //console.log('EXTERNAL props is ',props);

    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {}
}
